import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import CarContext from '../../context/CarContext'
import axios from 'axios'
import { TagManager } from '../../../helpers/TagManager'
// import { TagManager } from '../../../helpers/TagManager'

const CarFax = () => {

    const { car } = useContext(CarContext)
    const email = useRef();
    const phone = useRef();
    const [isValid, setIsValid] = useState(false);
    const [didSubmit, setDidSubmit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [PDFLink, setPDFLink] = useState(false);

    const storage = (id, value = false) => {
        const storage = JSON.parse(window.sessionStorage.getItem('bbCarFax') ?? '{}');
        if( ! value) {
            return storage[id] !== undefined ? storage[id] : false
        } else {
            storage[id] = value;
            window.sessionStorage.setItem('bbCarFax', JSON.stringify(storage));
        }
    }

    const webhook = useCallback( async (url, user_email, user_phone)=> {
        
        const data = {
            make: car.manufacturer,
            model: car.modelSeries,
            modelYear: car.modelYear,
            registrationNumber: car.registrationNumber,
            price: car.price,
            reportItems: car.carfax?.numberOfRecords || 0,
            reportUrl: url,
            vehicleUrl: window.location.href,
            vehicleDesc: `${car.title} ${car.shortDescription} ${car.description}`,
            email: user_email,
            phone: user_phone,
            subscribe: false
        }
        try {
            await axios.post('https://hook.integromat.com/1plh8kboc48l21j9hji4jrtgftltntno', data)
        } catch(error) {
            console.error({error})
        }

    },[car])
    
    const handleSubmit = useCallback( async (e)=>{
        e.preventDefault()
        setDidSubmit(true)

        if(!handleValidate()) {
            return false
        }

        // Read the inputs before setIsLoading unmounts the form and nulls the refs
        const user_email = email.current.value
        const user_phone = phone.current.value

        setIsLoading(true)

        // Make sure dataLayer exists
        TagManager({event:'Carfax', data:{ vehicleid: car._id, email: user_email, phone: user_phone }, format: false})

    
        const config = {
            params: {
                'id': car._id,
                'email': user_email,
                'phone': user_phone
            }
        }
        const url = `${process.env.REACT_APP_WAYKE_API_URL}/carfax`
        try {
            const results = await axios.get(url, config)
            if( ! results.data?.url) {
                // API answered 200 but without a report (e.g. {"msg":"Det finns inga Carfax poster..."})
                console.error('No Carfax report in response', results.data)
                alert(results.data?.msg ?? 'Tyvärr gick något fel, vänligen försök igen senare')
                setIsLoading(false)
                return
            }
            webhook(results.data.url, user_email, user_phone).catch(error => console.error({error}))
            storage(car._id, results.data.url)
            setPDFLink(results.data.url)    
            window.open(results.data.url, "_blank");
        } catch(error) {
            console.error({error})
            alert('Tyvärr gick något fel, vänligen försök igen senare')
        }
        setIsLoading(false)
    },[email, phone, car])

    const handleValidate = useCallback(()=>{
        const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)
        const valid = email.current.value.match(emailRegex) !== null ? true : false;
        const phoneRegex = new RegExp(/^\+?[0-9]{7,15}$/)
        const validPhone = phone.current.value.match(phoneRegex) !== null ? true : false;
        setIsValid( valid && validPhone )
        return valid && validPhone
    },[setIsValid, email, phone])


    useEffect(()=>{
        setPDFLink(storage(car._id))
        console.log(storage(car._id))
    },[])

    if( car.state === 'Ny' || car.carfax?.numberOfRecords === 0) {
        return ''
    }

    const getForm =  () => {
        return (
            <div className="carfax-form-wrapper">
                <div className="carfax-form">
                    <label className="label" htmlFor="e-post">Kontaktuppgifter</label>
                    <div className="field-container">
                        <input 
                            type="email" 
                            name="carfaxmail" 
                            placeholder="Ange din e-postadress*" 
                            ref={email}
                            className="email-field required"
                            required
                            onChange={handleValidate}
                        />
                        <input 
                            type="tel" 
                            name="carfaxphone" 
                            placeholder="Ange ditt telefonnummer*" 
                            ref={phone}
                            className="phone-field required"
                            required
                        />
                        <button 
                            className="btn btn-lg-black"
                            disabled={isLoading}
                            onClick={handleSubmit}
                        >Hämta rapport</button>
                    </div>
                    { !isValid && didSubmit && 
                        <span className="invalid">Ange en giltig e-postadress. ex. fornamn.efternamn@foretag.se och ett giltigt telefonnummer</span>
                    } 
                </div>
                <p><small>Alla personuppgifter som skickas in till Bilbolaget kommer att behandlas enligt <a href="/om-oss/personuppgiftshantering/">GDPR</a>.</small></p>
            </div>
        )
    }

    const getLink = () => {
        return (
            <div className="bb-button bb-btn-default align-inline my-2">
                <a href={PDFLink} rel="noopener noreferrer" target="_blank">Ladda ner CarFax rapport</a>
            </div>
        )
    }

    const getLoading = () => {
        return (
            <div className="loading container small">

            </div>
        )
    }



    return (
        <>
            <h2 className="section-title">
                Historik
                <CarFaxLogo />
            </h2>
            <p className="section-description">{`Bilbolaget bjuder på rapporten från Carfax till ett värde av 199 kr${car.carfax?.numberOfRecords > 0 ? ' som innehåller '+ car.carfax.numberOfRecords +' registrerade uppgifter':''}.`}</p>
            <ul className="is-style-checkmarks-medium">
                <li>Besiktningsdata</li>
                <li>Servicedata</li>
                <li>Mätarställning och eventuella felaktigheter</li>
            </ul>
            { isLoading 
                ? getLoading() 
                : (
                    PDFLink 
                        ? getLink() 
                        : getForm()
                ) 
            }
        </>
    )
}

export default CarFax


const CarFaxLogo = () => {
    return(
        <svg className="ml-2" id="carfax" xmlns="http://www.w3.org/2000/svg" width="80.3685" height="15" viewBox="0 0 107.158 20">
            <path id="Path_37" data-name="Path 37" d="M1.116.143C1.128.214,1.033.333.89.4a2.155,2.155,0,0,0-.845.881c-.226.417-.226,17.286,0,17.679a1.768,1.768,0,0,0,.833.857c.321.155,6.286.179,50.56.179,46.655,0,50.226-.012,50.6-.2a2.639,2.639,0,0,0,.679-.5l.262-.31V1.25l-.286-.333a1.791,1.791,0,0,0-.6-.44c-.167-.06-.3-.19-.3-.3,0-.155-5.31-.179-50.357-.179C13.092,0,1.092.036,1.116.143ZM101.9,1.262l.369.31v17.1l-.369.31-.369.31H51.545c-43.048,0-50.048-.024-50.333-.167a1.22,1.22,0,0,1-.464-.488C.64,18.4.6,16.226.6,10.083c.012-8.833,0-8.619.607-8.964C1.449.988,10.223.964,51.521.952h50.012Z" transform="translate(0.125 0)" fill="#1a171b"/>
            <path id="Path_38" data-name="Path 38" d="M14.2,15.051c-.036.083-.048,3.821-.036,8.31l.036,8.155,7.56.036c4.155.012,7.738,0,7.952-.036l.381-.071V15.051l-.262-.071c-.155-.036-3.714-.071-7.929-.071C15.893,14.908,14.238,14.944,14.2,15.051Zm9.833,2.655a3.83,3.83,0,0,1,2.56,2c.452.762.524,1.25.2,1.345-.3.1-.929.333-1.667.631a3.909,3.909,0,0,1-.726.25c-.071,0-.274-.25-.452-.56-.476-.833-.714-.976-1.488-.988a1.109,1.109,0,0,0-1.024.357c-1.1,1.071-1.06,4.31.048,5.226a2.11,2.11,0,0,0,.786.417A2.076,2.076,0,0,0,24,25.5c.417-.643.6-.667,1.4-.238,1.476.8,1.6.881,1.6,1.1a4.417,4.417,0,0,1-1.452,1.833,5.452,5.452,0,0,1-6.7-.488,5.784,5.784,0,0,1-1.488-4.357A5.752,5.752,0,0,1,19.2,18.682a5.727,5.727,0,0,1,4.833-.976Zm6.952-2.655c-.036.083-.048,3.821-.036,8.31l.036,8.155,7.774.036c5.226.012,7.845-.012,8.012-.1.226-.119.226-.321.226-8.214,0-7.869-.012-8.1-.226-8.214C46.405,14.836,31.06,14.86,30.988,15.051Zm9.667,2.869a3.609,3.609,0,0,1,.31.679,14.11,14.11,0,0,0,.679,1.9c.143.357.31.845.381,1.071a2.311,2.311,0,0,0,.214.536,1.332,1.332,0,0,1,.155.417c.036.167.179.6.31.952.452,1.155.619,1.6.75,2.024a2.311,2.311,0,0,0,.214.536,1.332,1.332,0,0,1,.155.417,8.089,8.089,0,0,0,.321.952,5.7,5.7,0,0,1,.321,1.036l.06.393h-3.19l-.2-.345a1.614,1.614,0,0,1-.2-.631,1.678,1.678,0,0,0-.238-.667l-.238-.381H38.976c-1.4,0-1.5.012-1.667.262a1.819,1.819,0,0,0-.262.69,3.371,3.371,0,0,1-.262.738l-.19.333h-3.19l.06-.321a5.733,5.733,0,0,1,.321-.988,8.09,8.09,0,0,0,.321-.952,1.332,1.332,0,0,1,.155-.417,2.311,2.311,0,0,0,.214-.536c.131-.429.3-.869.75-2.024.131-.357.274-.786.31-.952a1.333,1.333,0,0,1,.155-.417,2.311,2.311,0,0,0,.214-.536c.071-.226.238-.714.381-1.071.476-1.25.607-1.607.679-1.845a3.46,3.46,0,0,1,.571-1.155,7.369,7.369,0,0,1,1.512-.1h1.381Z" transform="translate(-12.462 -13.122)" fill="#1a171b"/>
            <path id="Path_39" data-name="Path 39" d="M216.365,21.658c-.119.56-.417,1.619-.583,2.083a.93.93,0,0,0-.083.5,3.763,3.763,0,0,0,1.631-.036.9.9,0,0,0-.107-.512,10.031,10.031,0,0,1-.512-1.857c-.083-.5-.25-.6-.345-.179Zm8.94-6.607c-.036.083-.048,3.821-.036,8.31l.036,8.155,7.56.036c4.155.012,7.738,0,7.952-.036l.381-.071V23.3c0-7.929-.012-8.155-.226-8.274C240.6,14.836,225.377,14.86,225.305,15.051Zm9.452,2.726a3.458,3.458,0,0,1,2.7,1.667c.31.488.333.619.333,1.774a3.246,3.246,0,0,1-.262,1.81c-.262.524-1.083,1.4-1.321,1.4-.274,0-.2.44.226,1.226,1.119,2.083,1.571,3.083,1.464,3.19a7.446,7.446,0,0,1-1.7.083l-1.6-.036-.917-1.833a13.117,13.117,0,0,0-1.083-1.929.941.941,0,0,0-.94.143,9.566,9.566,0,0,0-.107,1.857c0,2,.155,1.845-1.786,1.8l-1.25-.036-.036-5.476c-.012-3.012,0-5.548.036-5.631A33.381,33.381,0,0,1,234.757,17.777Z" transform="translate(-189.992 -13.122)" fill="#1a171b"/>
            <path id="Path_40" data-name="Path 40" d="M349.164,20.408a4.073,4.073,0,0,0-.012,2.071,12.2,12.2,0,0,0,2.548-.024,1.322,1.322,0,0,0,.357-.548,1.05,1.05,0,0,0-.488-1.476A4.832,4.832,0,0,0,349.164,20.408Zm10.393-5.357c-.036.083-.048,3.821-.036,8.31l.036,8.155,7.774.036c5.226.012,7.845-.012,8.012-.1.226-.119.226-.321.226-8.214,0-7.869-.012-8.1-.226-8.214C374.973,14.836,359.628,14.86,359.557,15.051Zm12.31,2.762a3.073,3.073,0,0,1,.107,1.333l-.036,1.179-2.8.036a16.118,16.118,0,0,0-2.857.143,4.323,4.323,0,0,0-.012,1.214,6.7,6.7,0,0,0,1.619.1c1.893,0,1.845-.036,1.845,1.369s.036,1.369-1.8,1.369c-1.226,0-1.56.036-1.607.167a20.82,20.82,0,0,0-.083,2.1c-.024,1.56-.06,1.94-.2,2.024a5.884,5.884,0,0,1-1.548.1l-1.369-.036-.036-5.476c-.012-3.012,0-5.548.036-5.631A54.935,54.935,0,0,1,371.866,17.813Zm4.56-2.762c-.226.226-.2,16.2.024,16.393.107.1,2.31.119,8,.107l7.845-.036V14.967l-7.857-.036c-6.024-.024-7.9.012-8.012.119Zm9.119,2.667c.25.071.476.452.738,1.238.06.167.214.6.357.952s.31.845.381,1.071a1.589,1.589,0,0,0,.226.524.647.647,0,0,1,.107.369.959.959,0,0,0,.167.476,1.961,1.961,0,0,1,.226.536c.036.167.179.6.31.952a19.485,19.485,0,0,1,.726,2,1.548,1.548,0,0,0,.214.536,1.4,1.4,0,0,1,.179.44,8.089,8.089,0,0,0,.321.952c.476,1.179.524,1.131-1.25,1.167a7.952,7.952,0,0,1-1.7-.083,1.056,1.056,0,0,1-.262-.56,6.333,6.333,0,0,0-.3-.917l-.179-.44h-1.548c-1.452,0-1.548.012-1.714.262a.986.986,0,0,0-.19.464,3.1,3.1,0,0,1-.238.75l-.25.548H380.33a5.589,5.589,0,0,1-1.607-.119c-.1-.155.048-.631.786-2.5.131-.357.274-.786.31-.952a1.962,1.962,0,0,1,.226-.536.958.958,0,0,0,.167-.476.647.647,0,0,1,.107-.369,1.589,1.589,0,0,0,.226-.524c.131-.429.286-.857.75-2.024.131-.357.274-.786.31-.952a1.333,1.333,0,0,1,.155-.417,2.311,2.311,0,0,0,.214-.536c.56-1.869.607-1.9,2.1-1.9A11.259,11.259,0,0,1,385.545,17.717Z" transform="translate(-307.458 -13.122)" fill="#1a171b"/>
            <path id="Path_41" data-name="Path 41" d="M638.742,18.207a2.626,2.626,0,0,0-.238.762,3.023,3.023,0,0,1-.19.738c-.286.726-.19.869.607.869s.857-.1.6-1.036c-.107-.381-.238-.917-.286-1.2-.131-.7-.214-.726-.488-.131Zm9.131-7.071c-.048.036-.083,3.762-.083,8.274,0,6.476.036,8.19.155,8.19h7.929c6.107,0,7.821-.036,7.893-.143.048-.083.1-3.75.1-8.143,0-6.048-.036-8.012-.143-8.119s-2.036-.143-7.952-.143c-4.3,0-7.857.036-7.893.083Zm15.512.56V27.147a3.585,3.585,0,0,1-1.19.1c-1.369,0-1.214.1-2.321-1.488-.393-.571-1.012-1.44-1.381-1.94a10.745,10.745,0,0,1-.738-1.143,1.914,1.914,0,0,1,.548-1.2c.131-.167,1.524-2.107,1.75-2.44.1-.143.4-.56.679-.94a3.515,3.515,0,0,0,.512-.821c0-.107-.429-.143-1.774-.143h-1.774l-.31.4a3.453,3.453,0,0,0-.309.464c0,.024-.238.417-.536.869a4.246,4.246,0,0,0-.536.964c0,.2-.31.2-.4,0-.036-.071-.167-.286-.286-.464s-.44-.7-.726-1.167a3.9,3.9,0,0,0-.738-.952,8.794,8.794,0,0,0-1.881-.119c-1.429,0-1.679.024-1.679.179a6.413,6.413,0,0,0,1.2,1.94c.357.464.881,1.2,1.179,1.631s.655.929.8,1.107a1.069,1.069,0,0,1,.274.548,8.034,8.034,0,0,1-.976,1.56c-.548.75-1.286,1.762-1.643,2.262l-.643.9-1.143-.036-1.131-.036v-15.6l7.321-.06c4.024-.036,7.44-.036,7.6-.012s.262.1.262.179ZM656,25.362a7.862,7.862,0,0,0,.738,1.25c.167.274.286.524.238.56a8.862,8.862,0,0,1-2.643-.048,3.81,3.81,0,0,1,.476-.821,4.194,4.194,0,0,0,.476-.81.539.539,0,0,1,.44-.393C655.825,25.1,655.944,25.219,656,25.362ZM667.194,11.2c0,.714.012.738.19.476s.2-.262.4-.083c.143.131.238.155.3.06.131-.2-.036-.476-.238-.4a.352.352,0,0,1-.452-.417.272.272,0,0,0-.071-.3C667.23,10.469,667.194,10.683,667.194,11.2Zm.952-.512c0,.2.214.25.286.071.036-.107,0-.179-.107-.179S668.147,10.624,668.147,10.683Zm.9.226a.153.153,0,0,0,.06.2c.179.119.3-.036.143-.19C669.171,10.838,669.1,10.838,669.051,10.909Zm0,.583c-.131.131-.071.274.107.274.1,0,.179-.048.179-.107C669.337,11.5,669.147,11.4,669.051,11.493Z" transform="translate(-562.179 -9.267)" fill="#1a171b"/>
        </svg>
    )
}